import svgAmbition1 from '/images/year-overview/ambition-1.svg'
import svgAmbition2 from '/images/year-overview/ambition-2.svg'
import svgAmbition3 from '/images/year-overview/ambition-3.svg'
import svgAmbition4 from '/images/year-overview/ambition-4.svg'

// Indexed by the number of beaten cities, which is Bolt's position in the ambition chart
export const AMBITION_CHART_IMAGES = [svgAmbition1, svgAmbition2, svgAmbition3, svgAmbition4]
